__turbopack_context__.v({
  "link": "Roz6lW_link",
});
